module.exports = __webpack_public_path__ + "img/wechat.3e6c036e.png";